import { render, staticRenderFns } from "./OrderToEdit.vue?vue&type=template&id=1f41b545&scoped=true&"
import script from "./OrderToEdit.vue?vue&type=script&lang=js&"
export * from "./OrderToEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrderToEdit.vue?vue&type=style&index=0&id=1f41b545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f41b545",
  null
  
)

export default component.exports